import { zodResolver } from "@hookform/resolvers/zod";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import { childVariantsStepper } from "../../animation/RoutesAnimations";
import { useForm } from "react-hook-form";
import SellerFormStep1 from "../../components/seller-form-steps/SellerFormStep1";
import customZ from "../../utils/setZodCustomMessages";
import { notEmptyField } from "../../utils/customSchemas";
import StepsTitle from "../../components/Stepper/StepsTitle";
import UserFormStep2 from "./UserFormStep2";
import UserFormStep3 from "./UserFormStep3";
import UserFormStep4 from "./UserFormStep4";
import { axiosPrivate } from "../../api/axios";
import { USER_STEP } from "../../api/apiClient";
import { useEffect } from "react";
import ShopsPage from "../shops/ShopsPage";

export interface IFormDataU {
  phone_number: number;
  national_id: number;
  birth_date: any;
  first_name: string;
  last_name: string;
  relation: string;
  phone_number_2: number;
  national_id_2: number;
  birth_date_2: any;
  first_name_2: string;
  last_name_2: string;
  relation_2: string;
  landlineNumber: string;
  homeAddress: string;
  postalCodeU: number;
  TypeofOwner: "owner" | "tenant" | undefined;
  job_industry: string;
  rank: string;
  job_title: string;
  monthly_income: string;
  workplace_name: string;
  insurance_number?: string;
  workplace_phone_number: string;
  workplace_postal_code: number;
  workplace_address: string;
  postal_code: string;
  tell_number: string;
  addresss: string;
  type: string;
  city: any;
  id: any;
}

const step4Schema = customZ.object({
  phone_number: notEmptyField,
  national_id: notEmptyField,
  first_name: notEmptyField,
  last_name: notEmptyField,
  relation: notEmptyField,
  phone_number_2: notEmptyField,
  national_id_2: notEmptyField,
  first_name_2: notEmptyField,
  last_name_2: notEmptyField,
  relation_2: notEmptyField,
});

const requestProductSchema = customZ.object({
  request_product: notEmptyField,
});

const step5Schema = customZ.object({});

const step6Schema = customZ.object({});

const step7Schema = customZ.object({});

const step8Schema = customZ.object({});

function UserStepper({ formNo, setFormNo, setEnteredUser, enteredUser }: any) {
  const {
    control,
    formState: { errors },
  } = useForm<IFormDataU>({
    resolver: (data, context, options) => {
      return zodResolver(
        formNo === 1
          ? requestProductSchema
          : formNo === 4
          ? step4Schema
          : formNo === 5
          ? step5Schema
          : formNo === 6
          ? step6Schema
          : formNo === 7
          ? step7Schema
          : step8Schema
      )(data, context, options);
    },
  });

  const getOrderGroupState = async () => {
    try {
      const response = await axiosPrivate.get(USER_STEP, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Content-Type": "multipart/form-data",
          Authorization:
            "Bearer " + window.localStorage.getItem("access_token"),
        },
        withCredentials: true,
      });
      if (response?.status >= 200 && response?.status < 300) {
        if (response?.data?.data?.step === "identity_info") {
          setFormNo(1);
          return;
        }
        if (response?.data?.data?.step === "residential_info") {
          setFormNo(1);
          return;
        }
        if (response?.data?.data?.step === "job_info") {
          setFormNo(3);
          return;
        }
        if (response?.data?.data?.step === "representatives_info") {
          setFormNo(4);
          return;
        }
        if (response?.data?.data?.step === "select_store") {
          setFormNo(1);
          return;
        }
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    getOrderGroupState();
  }, []);

  return (
    <motion.div className="">
      <div className="pt-4 z-10">
        <div
          className={`pt-4 gap-5 z-10 flex justify-center items-start w-screen max-w-screen-2xl mx-auto`}
        >
          {/* Stepper */}
          <motion.div
            variants={childVariantsStepper}
            initial="initial"
            animate="final"
            className={`mb-12 sticky top-10 ${
              formNo === 5 ? "hidden" : "hidden md:block"
            }`}
          >
            <StepsTitle isChildVisible formNo={formNo} sellerOrUser={"user"} />
          </motion.div>
          <div className="flex gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md ">
            {formNo === 1 && (
              <>
                <SellerFormStep1
                  isInSeller={false}
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                />
              </>
            )}
            {formNo === 2 && (
              <>
                <UserFormStep2
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                />
              </>
            )}
            {formNo === 3 && (
              <>
                <UserFormStep3
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                />
              </>
            )}
            {formNo === 4 && (
              <>
                <UserFormStep4
                  formNo={formNo}
                  setFormNo={setFormNo}
                  errors={errors}
                  control={control}
                />
              </>
            )}
            {formNo === 5 && (
              <>
                <ShopsPage
                  isInUserForm={true}
                  setEnteredUser={setEnteredUser}
                  enteredUser={enteredUser}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
export default UserStepper;
